"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
const InvoiceAbandonerRadioGroup = ({
  duplicateInvoice,
  onChangeOption,
  selectedOption
}) => {
  const invoiceNumber = duplicateInvoice.number;
  const amount = parseFloat(duplicateInvoice.source_invoice_amount).toFixed(2);
  const carrier = duplicateInvoice.carrier_name;
  const duplicateInvoiceText = `Duplicate of Invoice ${invoiceNumber} for $${amount} from ${carrier}`;
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsxs("div", { className: "row ignore-entry-view__radio-option", children: [
      /* @__PURE__ */ jsx(
        "input",
        {
          checked: selectedOption === "duplicate-invoice",
          id: "duplicate-invoice",
          onChange: onChangeOption,
          type: "radio",
          value: "duplicate-invoice"
        }
      ),
      /* @__PURE__ */ jsx("label", { htmlFor: "duplicate-invoice", children: duplicateInvoiceText })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "row ignore-entry-view__radio-option", children: [
      /* @__PURE__ */ jsx(
        "input",
        {
          checked: selectedOption === "ignore",
          id: "ignore",
          onChange: onChangeOption,
          type: "radio",
          value: "ignore"
        }
      ),
      /* @__PURE__ */ jsx("label", { htmlFor: "ignore", children: "Other" })
    ] })
  ] });
};
export default InvoiceAbandonerRadioGroup;
